<template>
  <div
    ref="chartEl"
    style="width: 100%; height: 280px;"
  ></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    dataInput: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      chartInstance: null
    };
  },

  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.chartInstance) {
        this.chartInstance.dispose();
    }
  },

  watch: {
    dataInput() {
      this.setOptions();
    }
  },

  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chartEl);
      this.setOptions();
    },

    setOptions() {
        const value = Math.max(0, Math.min(100, this.dataInput));

        if (!this.chartInstance) return;

        this.chartInstance.setOption({
            tooltip: { show: false },

            series: [
            // Soft drop-shadow outer ring
            {
                type: "pie",
                radius: "88%",
                silent: true,
                z: 0,
                zlevel: 0,
                label: { show: false },
                itemStyle: {
                color: "#ffffff",
                shadowColor: "rgba(0,0,0,0.18)",
                shadowBlur: 18
                },
                data: [{ value: 100 }]
            },

            // Thin Lavender Background Ring
            {
                type: "pie",
                radius: ["60%", "80%"],
                silent: true,
                z: 1,
                label: { show: false },
                data: [
                {
                    value: 100,
                    itemStyle: { color: "#E9E6F5" }
                }
                ]
            },

            // Thicker Orange Progress Ring
            {
                name: "Progress",
                type: "pie",
                radius: ["60%", "80%"],
                z: 2,
                clockwise: true,
                startAngle: 90,
                label: { show: false },
                labelLine: { show: false },

                data: [
                {
                    value: value,
                    itemStyle: { color: "#C56C00" }
                },
                {
                    value: 100 - value,
                    itemStyle: { color: "transparent" }
                }
                ]
            }
            ],

            graphic: [
            // % Text
            {
                type: "text",
                z:10,
                zlevel:1,
                left: "center",
                top: "44%",
                style: {
                text: value + "%",
                textAlign: "center",
                fontSize: 32,
                fontWeight: 800,
                fill: "#000"
                }
            },

            // Completed Text
            {
                type: "text",
                z:10,
                zlevel:1,
                left: "center",
                top: "56%",
                style: {
                text: "Completed",
                textAlign: "center",
                fontSize: 18,
                fontWeight: 500,
                fill: "#000"
                }
            }
            ]
        });
        },

    

    resizeChart() {
    if (this.chartInstance) {
        this.chartInstance.resize();
    }
    }
  }
};
</script>
